import SVGInjector from 'svg-injector';

function shortText(txt) {
    // remove html
    txt = txt.replace(/<[^>]+>/g, '');
    // trim the text and add ellipsis
    String.prototype.trimToLength = function (m) {
        return (this.length > m) ?
            this.trim().substring(0, m).split(" ").slice(0, -1).join(" ") + "..." :
            this;
    };
    return txt.trimToLength(200); // The function returns the product of p1 and p2
}

function arrayNiceString(arr) {
    if (arr.length == 1) {
        return arr[0];
    } else {
        var str = '';
        for (var i = 0; i < arr.length; i++) {
            str += arr[i];
            if (i < arr.length - 1) {
                str += ', ';
            }
        }
        return str;
    }
}

function loadSVGIcons() {
    if (!window.console) { console = { log: function () { } }; };

    // Elements to inject
    var mySVGsToInject = document.querySelectorAll('img.post_icon_image');

    // Options
    var injectorOptions = {
        evalScripts: 'once',
        pngFallback: 'assets/png',
        each: function (svg) {
            // Callback after each SVG is injected
        }
    };

    // Trigger the injection
    SVGInjector(mySVGsToInject, injectorOptions, function (totalSVGsInjected) {
        // Callback after all SVGs are injected
    });
}





function taxonomyToArray(obj) {
    var arr = [];
    for (var i = 0; i < obj.length; i++) {
        arr.push(obj[i].name);
    }
    return arr;
}


function getBgUrl(el) {
    var bg = "";
    if (el.currentStyle) { // IE
        bg = el.currentStyle.backgroundImage;
    } else if (document.defaultView && document.defaultView.getComputedStyle) { // Firefox
        bg = document.defaultView.getComputedStyle(el, "").backgroundImage;
    } else { // try and get inline style
        bg = el.style.backgroundImage;
    }

    if (bg == 'none') {
        return false;
    } else {
        return bg.replace(/url\(['"]?(.*?)['"]?\)/i, "$1");
    }
}

export { shortText, arrayNiceString, loadSVGIcons, taxonomyToArray, getBgUrl };